import { SportsApi } from '../../../API';
import { apiConfig } from '../../../utils/apiConfig';

export function useSportsAPI(): SportsApi {
  return new SportsApi(apiConfig);
}
